import { Injectable } from '@angular/core';
import { Http, Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { Observable }     from 'rxjs/Observable';

@Injectable()
export class DmCongViecService {

  constructor(private http:Http) { }

  DanhSach_CongViec(CV){
      let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data = CV;
      return this.http.post(Config.apiUrl + 'CongViec/DanhSach_CongViec', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
  }
  getListAll(){
      let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      return this.http.get(Config.apiUrl + 'CongViec/GetListAll', { headers: headers }).map(resp => resp.json());
  }
  Tao_CongViec(CV){
      let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data  = CV;
      return this.http.post(Config.apiUrl + 'CongViec/Tao_CongViec', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
  }
  Huy_CongViec(CV){
    let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data  = CV;
      return this.http.post(Config.apiUrl + 'CongViec/Huy_CongViec', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
  }
  TimKiem_CongViec(CV){
      let headers = new Headers();
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data  = CV;
      return this.http.post(Config.apiUrl + 'CongViec/DanhSachTiemKiem_CongViec', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
  }
  getDsCongViec(IdTinhThanh) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdTinhThanh : IdTinhThanh
        };
        return this.http.post(Config.apiUrl + 'CongViec/GetList', JSON.stringify(data), {headers: headers}).map(resp=>resp.json());
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/danhmuc/dm-cong-viec/dm-cong-viec.service.ts